import logo from '../assets/logo.jpg'
import tulsi from '../assets/tulsi.jpg'
import bunnyears from '../assets/bunnyears.jpg'
import bunnyears2 from '../assets/bunnyears2.jpg'
import bunnyears3 from '../assets/bunnyears3.jpg'
import bunnyears4 from '../assets/bunnyears4.jpg'
import bunnyears_yellow from '../assets/bunnyears_yellow.jpg'
import bunnyears_yellow2 from '../assets/bunnyears_yellow2.jpg'
import bunnyears_yellow3 from '../assets/bunnyears_yellow3.jpg'
import escobaria from '../assets/escobaria.jpg'
import escobaria_2 from '../assets/escobaria_2.jpg'
import laxmi_kamal from '../assets/laxmi_kamal.jpg'
import laxmi_kamal2 from '../assets/laxmi_kamal2.jpg'
import laxmi_kamal3 from '../assets/laxmi_kamal3.jpg'
import laxmi_kamal4 from '../assets/laxmi_kamal4.jpg'
import laxmi_kamal5 from '../assets/laxmi_kamal5.jpg'
import laxmi_kamal6 from '../assets/laxmi_kamal6.jpg'
import money from '../assets/money.jpg'
import money2 from '../assets/money2.jpg'
import money3 from '../assets/money3.jpg'
import money4 from '../assets/money4.jpg'
import snake1 from '../assets/snake1.jpg'
import snake2 from '../assets/snake2.jpg'
import snake3 from '../assets/snake3.jpg'
import stonecrop from '../assets/stonecrop.jpg'
import stonecrop2 from '../assets/stonecrop2.jpg'
import stonecrop3 from '../assets/stonecrop3.jpg'
import stonecrop4 from '../assets/stonecrop4.jpg'
import supplera from '../assets/supplera.jpg'
import supplera2 from '../assets/supplera2.jpg'
import kalanchoe from '../assets/kalanchoe.jpg'
import kalanchoe2 from '../assets/kalanchoe2.jpg'
import guldavari from '../assets/guldavari.jpg'
import guldavari2 from '../assets/guldavari2.jpg'
import guldavari3 from '../assets/guldavari3.jpg'
import wallpaper from '../assets/wallpaper.jpg'

export default {
  logo,
  tulsi,
  bunnyears,
  bunnyears2,
  bunnyears3,
  bunnyears4,
  bunnyears_yellow,
  bunnyears_yellow2,
  bunnyears_yellow3,
  escobaria,
  escobaria_2,
  laxmi_kamal,
  laxmi_kamal2,
  laxmi_kamal3,
  laxmi_kamal4,
  laxmi_kamal4,
  laxmi_kamal5,
  laxmi_kamal6,
  money,
  money2,
  money3,
  money4,
  snake1,
  snake2,
  snake3,
  stonecrop,
  stonecrop2,
  stonecrop3,
  stonecrop4,
  supplera,
  supplera2,
  kalanchoe,
  kalanchoe2,
  guldavari,
  guldavari2,
  guldavari3,
  wallpaper
}